import { apiClient } from "../api/client";
import type { LedgerEntry } from "../api/types";

// fetchAllLedger walks the ledger cursor for a season until exhausted.
// Backend caps page size at 100 (httpapi.MaxPageLimit), so dashboards/
// directories that need season-wide aggregates have to page through.
// Hard-stop after `safetyLimit` pages so a misbehaving cursor can't loop
// forever.
export async function fetchAllLedger(
  seasonID: string,
  options: { userID?: string; pageSize?: number; safetyLimit?: number } = {}
): Promise<LedgerEntry[]> {
  const pageSize = options.pageSize ?? 100;
  const safetyLimit = options.safetyLimit ?? 50;
  const all: LedgerEntry[] = [];
  let cursor: string | undefined;
  for (let i = 0; i < safetyLimit; i += 1) {
    const page = await apiClient.listLedger({
      seasonID,
      ...(options.userID !== undefined ? { userID: options.userID } : {}),
      ...(cursor !== undefined ? { cursor } : {}),
      limit: pageSize
    });
    all.push(...page.entries);
    if (page.next_cursor === undefined || page.next_cursor === "") {
      return all;
    }
    cursor = page.next_cursor;
  }
  return all;
}
